// @ts-nocheck
// ----------------------------------------------------------------------

export default function Dialog(theme) {
  return {
    MuiDialog: {
      styleOverrides: {
        paper: {
          boxShadow: theme.customShadows.z24,
          '&.MuiPaper-rounded': {
            borderRadius: theme.shape.borderRadiusMd
          },
          '&.MuiDialog-paperFullScreen': {
            // A full-screen dialog must bleed edge-to-edge. Without this the
            // `@media (max-width:600px) { margin: 16 }` rule below also hits
            // full-screen papers, making them 100vw + 32px wide — that
            // horizontal overflow pushes the top-right close button off the
            // screen. Higher specificity (two classes) wins over that rule.
            borderRadius: 0,
            margin: 0,
            width: '100%',
            maxWidth: '100%',
            maxHeight: '100%'
          },
          '&.MuiDialog-paper .MuiDialogActions-root': {
            padding: theme.spacing(3)
          },
          '@media (max-width: 600px)': {
            margin: theme.spacing(2),
            // Cap every paper (incl. fullWidth, whose width override is 100%)
            // to the viewport minus its 16px margins. Without this the paper
            // runs 100% + 32px wide on phones and the top-right close button
            // ends up off-screen. The full-screen rule above is more specific
            // and still bleeds edge-to-edge.
            maxWidth: 'calc(100% - 32px)',
            width: 'calc(100% - 32px)'
          },
          '@media (max-width: 663.95px)': {
            '&.MuiDialog-paperWidthSm.MuiDialog-paperScrollBody': {
              maxWidth: '100%'
            }
          }
        },
        paperFullWidth: {
          width: '100%'
        }
      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 3, 0)
        }
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          borderTop: 0,
          borderBottom: 0,
          padding: theme.spacing(3)
        }
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          '& > :not(:first-of-type)': {
            marginLeft: theme.spacing(1.5)
          }
        }
      }
    }
  };
}